function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-62.000000, -988.000000)",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.000000, 86.000000)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(41.000000, 902.000000)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(21.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M13,0 C5.832125,0 0,4.77658286 0,10.6473898 C0,13.6466776 1.5145,16.4592266 4.1795,18.4707642 C3.38,19.6583577 2.19375,20.924578 0.6175,21.3193505 C0.2405,21.414358 -0.017875,21.7632647 0.001625,22.1547611 C0.021125,22.5462574 0.310375,22.8689552 0.6955,22.9246492 C0.754,22.9328395 1.236625,23 2.029625,23 C3.679,23 6.667375,22.7084253 9.949875,20.9950146 C10.92325,21.1932199 11.947,21.2947796 13,21.2947796 C20.167875,21.2947796 26,16.5181967 26,10.6473898 C26,4.77658286 20.167875,0 13,0 Z M6.5,13.1044797 C5.603,13.1044797 4.875,12.3706289 4.875,11.4664198 C4.875,10.5622107 5.603,9.8283598 6.5,9.8283598 C7.397,9.8283598 8.125,10.5622107 8.125,11.4664198 C8.125,12.3706289 7.397,13.1044797 6.5,13.1044797 Z M13,13.1044797 C12.103,13.1044797 11.375,12.3706289 11.375,11.4664198 C11.375,10.5622107 12.103,9.8283598 13,9.8283598 C13.897,9.8283598 14.625,10.5622107 14.625,11.4664198 C14.625,12.3706289 13.897,13.1044797 13,13.1044797 Z M19.5,13.1044797 C18.603,13.1044797 17.875,12.3706289 17.875,11.4664198 C17.875,10.5622107 18.603,9.8283598 19.5,9.8283598 C20.397,9.8283598 21.125,10.5622107 21.125,11.4664198 C21.125,12.3706289 20.397,13.1044797 19.5,13.1044797 Z",
  id: "Shape"
}))))));

const SvgIcContact = (_ref) => {
  let svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "23px",
    viewBox: "0 0 26 23",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcContact, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic-contact.1ad7396c.svg";
export { ForwardRef as ReactComponent };